import { instance as axios } from '../untils/http'
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { errorHandler } from '../untils/errorHandler';
import { ErrorInformation } from 'src/models/errorInformation';
import { PerformanceUserViewAward, PerformanceUserViewAwardDetail, PerformanceViewAwardAchievementFactor } from 'src/models/performanceViewAwardDetail';

//================|| PERFORMANCE VIEW AWARD DETAIL SLICE ||=================//
type PerformanceViewAwardDetailState = {
    loading: boolean;
    error: ErrorInformation;
    performanceViewAwards: PerformanceUserViewAward[];
    performanceViewAwardDetail: PerformanceUserViewAwardDetail;
    awardLetter: string,
    performanceAchievementFactor: PerformanceViewAwardAchievementFactor

}
type AwardNoAndID = {
    awardNo: string,
    awardLetterID: number
}
const initialState: PerformanceViewAwardDetailState = {
    loading: true,
    error: null,
    performanceViewAwards: [],
    performanceViewAwardDetail: {
        conditionsViewModels: [],
        vestingViewModels: []
    },
    awardLetter: '',
    performanceAchievementFactor: {
        kpiModels: [],
        achievementModels: []
    }
};

export const getPerformanceViewAward = createAsyncThunk<PerformanceUserViewAward[], {}, { rejectValue: ErrorInformation }>(
    "performanceViewAwardDetail/getPerformanceViewAward",
    async ({ }, { rejectWithValue }) => {
        try {
            const performanceViewAwardResponse = await axios.get<PerformanceUserViewAward[]>('PerformanceShare/getPerformanceUserViewAward');
            return performanceViewAwardResponse.data
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
);

export const getPerformanceViewAwardDetail = createAsyncThunk(
    "performanceViewAwardDetail/getPerformanceViewAwardDetail",
    async (awardNo: string, { rejectWithValue }) => {
        try {
            const performanceViewAwardDetailResponse = await axios.get<PerformanceUserViewAwardDetail>(`PerformanceShare/getPerformanceUserViewAwardDetails?awardNo=${awardNo}`)
            return performanceViewAwardDetailResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)
export const getPerformanceAwardLetter = createAsyncThunk(
    "performanceViewAwardDetail/getPerformanceAwardLetter",
    async (awardNoAndID: AwardNoAndID, { rejectWithValue }) => {
        try {
            console.log(awardNoAndID);
            const performanceAwardLetterResponse = await axios.get<string>(`PerformanceShare/getPerformanceAwardLetterTemplate?awardNo=${awardNoAndID.awardNo}&awardLetterID=${awardNoAndID.awardLetterID}`)
            return performanceAwardLetterResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)


export const getPerformanceAwardAchievementFactor = createAsyncThunk<PerformanceViewAwardAchievementFactor, { awardNo: string }, { rejectValue: ErrorInformation }>(
    "performanceViewAwardDetail/getPerformanceAwardAchievementFactor",
    async ({ awardNo }, { rejectWithValue }) => {

        try {
            const performanceAwardLetterResponse = await axios.get<PerformanceViewAwardAchievementFactor>(`PerformanceShare/getPerformanceViewAwardFactor?awardNo=${awardNo}`)
            return performanceAwardLetterResponse['data']
        } catch (error) {
            return rejectWithValue(errorHandler(error))
        }
    }
)
const performanceViewAwardDetailSlice = createSlice({
    name: 'performanceViewAwardDetail',
    initialState,
    reducers: {},
    extraReducers: {
        //get Performance View Award
        [getPerformanceViewAward.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceViewAward.fulfilled.type]: (state, action) => {
            state.performanceViewAwards = action.payload;
            state.loading = false;
        },
        [getPerformanceViewAward.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },

        // get Performance View Award Detail
        [getPerformanceViewAwardDetail.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceViewAwardDetail.fulfilled.type]: (state, action) => {
            state.performanceViewAwardDetail = action.payload;
            state.loading = false;
        },
        [getPerformanceViewAwardDetail.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },


        // get Performance Award Letter
        [getPerformanceAwardLetter.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardLetter.fulfilled.type]: (state, action) => {
            state.awardLetter = action.payload;
            state.loading = false;
        },
        [getPerformanceAwardLetter.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },


        // get Performance Award Achievement Factor
        [getPerformanceAwardAchievementFactor.pending.type]: (state) => {
            state.loading = true;
        },
        [getPerformanceAwardAchievementFactor.fulfilled.type]: (state, action) => {
            state.performanceAchievementFactor = action.payload;
            console.log(action.payload)
            state.loading = false;
        },
        [getPerformanceAwardAchievementFactor.rejected.type]: (state, action: PayloadAction<ErrorInformation | null>) => {
            state.loading = false;
            state.error = action.payload
        },
    }
})
export default performanceViewAwardDetailSlice